import { MoonIcon, SunIcon } from 'lucide-react'
import { useTheme } from '@/shared/ui/providers'
import { cn } from '@/shared/ui/cn'
import { Switch } from '@/shared/ui/primitives'

export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme()
  const isDark = resolvedTheme === 'dark'
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode'

  return (
    <div className="flex shrink-0 items-center gap-2">
      <SunIcon
        aria-hidden="true"
        className={cn(
          'size-4 transition-colors',
          isDark ? 'text-muted-foreground' : 'text-primary',
        )}
      />
      <Switch
        checked={isDark}
        onCheckedChange={(next) => setTheme(next ? 'dark' : 'light')}
        aria-label={label}
        title={label}
      />
      <MoonIcon
        aria-hidden="true"
        className={cn(
          'size-4 transition-colors',
          isDark ? 'text-primary' : 'text-muted-foreground',
        )}
      />
    </div>
  )
}
